export const normalizeEntityForUi = entity => {
  if (!entity) return entity;
  return {
    ...entity,
    form_options: entity.form_options,
    icon_link: entity.icon_link ?? entity.form_options?.icon,
  };
};

export const normalizeEntityListResponse = response => {
  if (!response?.entities) return response;
  return {
    ...response,
    schemas: response.entities.map(normalizeEntityForUi),
  };
};

export const normalizeEntityResponse = response => {
  if (!response) return response;
  if (response.entities) return normalizeEntityListResponse(response);
  return normalizeEntityForUi(response);
};
